<template>
  <el-form-item ref="formItem" class="sky-url-link">
    <el-button type="text" @click="openUrl">
      专业致胜申请链接
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Button } from 'element-ui'

export default {
  name: 'SkyWinUrlLink',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  methods: {
    openUrl() {
      window.open('https://project.feishu.cn/professional_wins/yzm/homepage', '_blank')
    }
  }
}
</script>
